import { Box, Button } from "@braintrust/braintrust-ui-components";
import { LogOutIcon } from "@braintrust/braintrust-ui-components/Icons";
import { RouterLink } from "@js/components/link";
import { Logo } from "@js/components/logo";

export const OnboardingPage = ({ children }: { children: React.ReactNode }) => {
  return (
    <Box>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: {
            xs: 2,
            sm: 4,
            md: "calc(35vh - 12rem)",
          },
        }}
      >
        <Box sx={{ marginLeft: "20px", marginTop: "20px" }}>
          <Logo alt="Braintrust" />
        </Box>
        <Box sx={{ marginRight: "4px", marginTop: "13px" }}>
          <Button
            RouterLink={RouterLink}
            to="/auth/logout/"
            variant="transparent"
            fontWeight={400}
            endIcon={<LogOutIcon style={{ fontSize: 24 }} />}
          >
            Logout
          </Button>
        </Box>
      </Box>
      <Box sx={{ margin: "auto", maxWidth: "712px", padding: 3 }}>
        {children}
      </Box>
    </Box>
  );
};
